require('./helpers/bundle-manifest').register(JSON.parse("{\"h00hi\":\"index.2a1be409.js\",\"7yE4W\":\"service-worker.js\",\"5ygTe\":\"index.45ccbcf5.css\"}"));